import React from 'react'

export const C = {
  dark: '#0a0a0b',
  dark2: '#0e1018',
  dark3: '#141820',
  card: '#0d1019',
  white: '#ffffff',
  light: '#f7f7f8',
  tx: '#0d0f14',
  tx2: 'rgba(13,15,20,0.55)',
  tx3: 'rgba(13,15,20,0.3)',
  ltx: '#ffffff',
  ltx2: 'rgba(255,255,255,0.65)',
  ltx3: 'rgba(255,255,255,0.3)',
  primary: '#f7931a',
  primaryDark: '#d97b0f',
  bdr: 'rgba(0,0,0,0.08)',
  dbdr: 'rgba(255,255,255,0.08)',
  up: '#3ecf8e',
  down: '#f06060',
  blue: '#4098ff',
}

export const fOutfit = "'Poppins', sans-serif"
export const fMono = "'Poppins', sans-serif"
export const fBody = "'Poppins', sans-serif"

export function LogoMark({ size = 28 }) {
  return (
    <img
      src="/assets/images/logo-mark.png"
      alt="Xperia Capital"
      style={{ height: size, width: 'auto', flexShrink: 0, display: 'block' }}
    />
  )
}

export function Wordmark({ size = 15 }) {
  return (
    <span style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: size, letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>
      <span style={{ color: C.primary }}>Xperia</span> <span style={{ color: C.ltx }}>Capital</span>
    </span>
  )
}

export const REG_FLAGS = [
  { country: 'mu', code: 'FSC' },
  { country: 'gb', code: 'FCA' },
  { country: 'ae', code: 'CMA' },
  { country: 'za', code: 'FSCA' },
  { country: 'au', code: 'ASIC' },
  { country: 'nz', code: 'FMA' },
  { country: 'sc', code: 'FSA' },
]

export function FlagBadge({ country, size = 44 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', position: 'relative', overflow: 'hidden', flexShrink: 0,
      boxShadow: '0 4px 8px rgba(0,0,0,0.5), inset 0 -4px 8px rgba(0,0,0,0.45), inset 0 3px 5px rgba(255,255,255,0.3)',
    }}>
      <span className={`fi fi-${country}`} style={{ width: size, height: size, backgroundSize: 'cover', display: 'block' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'radial-gradient(circle at 32% 26%, rgba(255,255,255,0.6), rgba(255,255,255,0) 55%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', boxShadow: 'inset 0 -7px 10px rgba(0,0,0,0.5)', pointerEvents: 'none' }} />
    </div>
  )
}

export const SOCIAL_LINKS = [
  {
    label: 'X (Twitter)',
    icon: <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />,
  },
  {
    label: 'Telegram',
    icon: <path d="M3 9.8l14-6-2.4 13-4-3.2-2 3-1-4.4-4.6-2.4z" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />,
  },
  {
    label: 'LinkedIn',
    icon: <text x="10" y="14" textAnchor="middle" fontSize="11" fontWeight="800" fill="currentColor" fontFamily="Poppins, sans-serif">in</text>,
  },
  {
    label: 'YouTube',
    icon: <><rect x="2" y="5" width="16" height="10" rx="3" fill="none" stroke="currentColor" strokeWidth="1.3" /><path d="M8.5 7.8l4 2.2-4 2.2V7.8z" fill="currentColor" /></>,
  },
]

export const TRADING_MENU = [
  {
    title: 'Market Instruments',
    links: [
      { label: 'Forex Pairs', to: '/trading/forex-pairs' },
      { label: 'Precious Metals', to: '/trading/precious-metals' },
      { label: 'Energies', to: '/trading/energies' },
      { label: 'Indices', to: '/trading/indices' },
      { label: 'Cryptocurrencies', to: '/trading/cryptocurrencies' },
    ],
  },
  {
    title: 'Account Types',
    links: [
      { label: 'Account Comparison', to: '/trading/account-comparison' },
      { label: 'STD Account', to: '/trading/std-account' },
      { label: 'ECN Account', to: '/trading/ecn-account' },
      { label: 'PRO Account', to: '/trading/pro-account' },
    ],
  },
  {
    title: 'Trading Conditions',
    links: [
      { label: 'Leverage', to: '/trading/leverage' },
      { label: 'Pricing', to: '/trading/pricing' },
    ],
  },
]

export const RESOURCES_MENU = [
  {
    title: 'Learn',
    links: [
      { label: 'Xperia Academy', to: '/resources/academy' },
      { label: 'Glossary', to: '/resources/glossary' },
    ],
  },
  {
    title: 'Markets',
    links: [
      { label: 'Market Insights', to: '/resources/market-insights' },
      { label: 'News & Updates', to: '/resources/news' },
    ],
  },
]

export const COMPANY_MENU = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/company/about' },
      { label: 'Careers', to: '/company/careers' },
    ],
  },
  {
    title: 'Trust',
    links: [
      { label: 'Regulation & Licences', to: '/company/regulation' },
      { label: 'Legal', to: '/company/legal' },
      { label: 'Contact', to: '/company/contact' },
    ],
  },
]

export function NavDropdown({ label, to, active, menu, linkTrigger }) {
  const [open, setOpen] = React.useState(false)
  const Trigger = linkTrigger ? 'a' : 'span'
  return (
    <div
      style={{ position: 'relative', paddingBottom: '24px', marginBottom: '-24px' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Trigger
        href={linkTrigger ? to : undefined}
        onClick={linkTrigger ? undefined : () => setOpen(o => !o)}
        style={{ fontSize: '13px', color: active === label ? C.primary : C.ltx2, fontWeight: active === label ? 500 : 400, display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', textDecoration: 'none' }}
      >
        {label}
        <svg width="9" height="9" viewBox="0 0 10 10" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}><path d="M2 3.5l3 3 3-3" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </Trigger>
      {open && (
        <div style={{
          position: 'absolute', top: '44px', left: 0, background: C.dark2, border: `1px solid ${C.dbdr}`,
          borderRadius: '12px', padding: '20px', display: 'flex', gap: '36px', boxShadow: '0 16px 40px rgba(0,0,0,0.5)', zIndex: 100,
        }}>
          {menu.map(col => (
            <div key={col.title} style={{ minWidth: '150px' }}>
              <div style={{ fontSize: '11px', color: C.ltx3, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '12px', whiteSpace: 'nowrap' }}>{col.title}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {col.links.map(l => (
                  <a key={l.label} href={l.to} style={{ fontSize: '13px', color: C.ltx2, whiteSpace: 'nowrap' }}>{l.label}</a>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export function PublicNav({ active }) {
  return (
    <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: 'rgba(10,10,11,0.75)', backdropFilter: 'blur(20px) saturate(160%)', WebkitBackdropFilter: 'blur(20px) saturate(160%)', borderBottom: `1px solid ${C.dbdr}` }}>
      <div style={{ maxWidth: '1320px', margin: '0 auto', padding: '0 40px', display: 'flex', alignItems: 'center', height: '60px', gap: '48px', flexWrap: 'wrap' }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
          <LogoMark size={34} />
          <Wordmark size={16} />
        </a>
        <div style={{ display: 'flex', gap: '28px', flex: 1, alignItems: 'center', flexWrap: 'wrap' }}>
          <a href="/" style={{ fontSize: '13px', color: active === 'Home' ? C.primary : C.ltx2, fontWeight: active === 'Home' ? 500 : 400 }}>Home</a>
          <NavDropdown label="Trading" active={active} menu={TRADING_MENU} linkTrigger={false} />
          <NavDropdown label="Resources" to="/resources" active={active} menu={RESOURCES_MENU} linkTrigger={true} />
          <NavDropdown label="Company" to="/company" active={active} menu={COMPANY_MENU} linkTrigger={true} />
        </div>
        <a href="/login" style={{ fontSize: '13px', fontWeight: 600, background: C.primary, color: C.dark, padding: '9px 20px', borderRadius: '999px', textDecoration: 'none', flexShrink: 0 }}>Log In</a>
      </div>
    </nav>
  )
}

export function PublicFooter() {
  return (
    <footer style={{ background: C.dark, borderTop: `1px solid ${C.dbdr}` }}>
      <div style={{ maxWidth: '1320px', margin: '0 auto', padding: '48px 40px 32px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '32px', justifyContent: 'space-between', marginBottom: '32px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            <LogoMark size={26} />
            <Wordmark size={14} />
          </div>
          <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', alignItems: 'center' }}>
            {REG_FLAGS.map(({ country, code }) => (
              <div key={code} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <FlagBadge country={country} size={32} />
                <span style={{ fontSize: '9px', color: C.ltx3, fontWeight: 600 }}>{code}</span>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {SOCIAL_LINKS.map(({ label, icon }) => (
              <a key={label} href="#" aria-label={label} style={{ width: '32px', height: '32px', border: '1px solid rgba(255,255,255,0.18)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.ltx2 }}>
                <svg width="18" height="18" viewBox="0 0 20 20">{icon}</svg>
              </a>
            ))}
          </div>
        </div>
        <div style={{ borderTop: `1px solid ${C.dbdr}`, paddingTop: '20px' }}>
          <p style={{ fontSize: '12px', color: C.ltx3 }}>This website is operated by Xperia Capital Limited (Mauritius). Trading involves risk and may result in losses exceeding your deposit.</p>
        </div>
      </div>
    </footer>
  )
}
